export const SET_SHARE_RESTAURANT_NAME = "SET_SHARE_RESTAURANT_NAME";
export const SET_SHARE_IS_BOX_OPEN = "SET_SHARE_IS_BOX_OPEN";